import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import ComplianceAnalysisBypassPopupStore from "./ComplianceAnalysisBypassPopupStore";

const ComplianceAnalysisBypassController = declare(Controller, {

	/** 
	 * @override 
	 * use store instead of actioncontroller 
	 */
	async onReactViewProps(props) {
		const { m_action, m_cache, m_writer } = this;
		props.store = new ComplianceAnalysisBypassPopupStore(m_action.getId(), m_writer, this.getNode().$URL, m_cache, props.onSave);
	},
});

export = ComplianceAnalysisBypassController;	